<template>
  <div class="header-tabbar-wrapper">
    <div class="auto-box herder-box">
      <div class="header-logo" v-if="headerLogo" @click="handleToHome">
        <img :src="headerLogo" alt="" />
      </div>
      <div class="header-title ellipsis-1" @click="handleToHome" v-else>
        {{ meetingInfo?.platformName || "大会官网" }}
      </div>
      <div class="header-right">
        <!-- 菜单导航栏 -->
        <div class="menu-wrapper">
          <div
            class="menu-item ellipsis-1"
            v-for="item in showMenu"
            :key="item.subjectId"
            :class="{ active: active === item.subjectId }"
            @click="handleChange(item)"
          >
            <a-popover>
              <template #content v-if="item.subjectName.length >= 7">
                <span> {{ item.subjectName }}</span>
              </template>
              <span>{{ item.subjectName }}</span>
            </a-popover>
          </div>

          <a-popover
            :getPopupContainer="
              (triggerNode) => {
                return triggerNode.parentNode || document.body;
              }
            "
            v-if="otherMenu.length > 0"
          >
            <template #content>
              <div
                class="other-menu-item"
                :class="{ active: otherMenuActiveId === menu.subjectId }"
                v-for="menu in otherMenu"
                :key="menu.subjectId"
                @click="handleClickOtherMenu(menu)"
              >
                {{ menu.subjectName }}
              </div>
            </template>
            <div
              class="menu-item"
              :class="{ active: isOtherActive }"
              v-if="tabList.length > 5"
            >
              <img
                width="20"
                height="20"
                src="../../assets/pc/menu-more.png"
                alt=""
              />
            </div>
          </a-popover>
        </div>

        <div class="user-box" v-if="isLogin">
          <a-popover
            :getPopupContainer="
              (triggerNode) => {
                return triggerNode.parentNode || document.body;
              }
            "
          >
            <div class="flex items-center space-between">
              <img
                src="../../assets/pc/user-logo.png"
                alt=""
                class="user-logo"
              />
              <span class="username">{{
                isLogin.phone
                  ? isLogin.phone.slice(0, 3) + "****" + isLogin.phone.slice(7)
                  : isLogin.userName
              }}</span>
            </div>
            <template #content>
              <div class="person-menu-item" @click="toMy">个人中心</div>
              <div class="person-menu-item" @click="handleLogout">退出</div>
            </template>
          </a-popover>
        </div>
        <div class="user-box" @click="handleLogin" v-else>
          <img src="../../assets/pc/user-logo.png" alt="" class="user-logo" />
          <span class="username">登录</span>
        </div>
      </div>
    </div>
    <!-- 新版登录框 -->
    <LoginModal ref="LoginModalRef" @loginSuccess="onLoginSuccess" />
  </div>
</template>
<script setup>
import { ref, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import store from "@/store";
import { getSubjectDetail } from "@/api/meeting";
import { message } from "ant-design-vue";

import LoginModal from "./LoginModal.vue";

const LoginModalRef = ref(null);
const router = useRouter();
const route = useRoute();
const isLogin = computed(() => store.getters["user/getUserInfo"]);
// const isLogin = ref(false);
// watch(
//   () => localStorage.getItem("token"),
//   (val) => {
//     isLogin.value = val;
//   }
// );
const headerLogo = computed(() => store.getters["config/getConfig"].topLogo);
const meetingInfo = store.getters["config/getConfig"];
const tabList = store.getters["config/getTabList"];
const showMenu = computed(() => {
  if (tabList.length > 7) {
    return tabList.slice(0, 6);
  }
  return tabList;
});
const otherMenu = computed(() => {
  if (tabList.length > 7) {
    return tabList.slice(6);
  }
  return [];
});
const isOtherActive = ref(false);
const otherMenuActiveId = ref(-2);

const active = ref(-1);
// 1-外链;2-子菜单;5-会议;6-资讯;7-附件;8-课程 11-图文 12-图文+附件 13-投稿 14-日程
const RoutesName = {
  1: "link",
  11: "RichText",
  12: "Attachments",
  13: "Contribute",
  14: "Schedule",
};
const handleChange = async (item) => {
  // isOtherActive.value = false;
  // otherMenuActiveId.value = 0;
  // active.value = item.subjectId;
  if (item.subjectType == 1) {
    const { results } = await getSubjectDetail({ subjectId: item.subjectId });
    if (results[0] && results[0].url) {
      const url = results[0].url.split(",");
      if (url.length > 1) {
        window.open(url[1], "_blank");
      } else {
        window.open(url[0], "_blank");
      }
    } else {
      message.warn("敬请期待！");
    }
  } else {
    router.push({
      name: RoutesName[item.subjectType],
      query: { id: item.subjectId },
    });
  }
};
const handleClickOtherMenu = async (item) => {
  // active.value = 0;
  // otherMenuActiveId.value = item.subjectId;
  // isOtherActive.value = true;
  if (item.subjectType == 1) {
    const { results } = await getSubjectDetail({ subjectId: item.subjectId });
    if (results && results.length > 0 && results[0].url) {
      const url = results[0].url.split(",");
      if (url.length > 1) {
        window.open(url[1], "_blank");
      } else {
        window.open(url[0], "_blank");
      }
    } else {
      message.warn("敬请期待！");
    }
  } else {
    router.push({
      name: RoutesName[item.subjectType],
      query: { id: item.subjectId },
    });
  }
};

const handleLogin = () => {
  if (!isLogin.value) {
    LoginModalRef.value.showModal();
    // store.commit("user/setPcLoginPop", true);
  }
};

const handleLogout = async () => {
  await store.dispatch("user/logout");
  if (route.name == "My") {
    router.push("/");
  }
};
const onLoginSuccess = () => {
  toMy();
};
const toMy = () => {
  router.push("/my");
};

const handleToHome = () => {
  const pcIndex = store.getters["config/getPcIndexPath"];
  if (pcIndex == route.fullPath) return;
  router.push(pcIndex);
};
// :getPopupContainer="getPopupContainer"
// const getPopupContainer = (triggerNode) => triggerNode.parentNode.parentNode;
watch(
  () => route.query.id,
  (val) => {
    if (val) {
      const find = showMenu.value.find((item) => item.subjectId == val);
      if (find) {
        active.value = find.subjectId;
        isOtherActive.value = false;
        otherMenuActiveId.value = 0;
      } else {
        const find = otherMenu.value.find((item) => item.subjectId == val);
        if (find) {
          active.value = 0;
          isOtherActive.value = true;
          otherMenuActiveId.value = find.subjectId;
        }
      }
    } else {
      active.value = 0;
      isOtherActive.value = false;
      otherMenuActiveId.value = 0;
    }
  },
  {
    immediate: true,
  }
);
</script>
<style lang="less" scoped>
.header-tabbar-wrapper {
  position: fixed;
  z-index: 99;
  top: 0;
  width: 100%;
  height: 60px;
  background: rgba(255, 255, 255, 0.59);
  backdrop-filter: blur(10px);
  line-height: 60px;
}

.herder-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header-logo {
    width: 358px;
    height: 100%;
    display: flex;
    align-items: center;
    img {
      height: 26px;
      cursor: pointer;
    }
  }
}

.header-title {
  width: 358px;
  font-family: AlibabaPuHuiTi_2_105_Heavy;
  font-size: 21px;
  color: #333;
  text-align: left;
  cursor: pointer;
}

.header-right {
  display: flex;
  align-items: center;
}

.menu-wrapper {
  display: flex;
  column-gap: 42px;
  align-items: center;
}
.menu-item {
  position: relative;
  cursor: pointer;
  max-width: 80px;
}
::v-deep(.ant-popover) {
  .ant-popover-content {
    margin-top: -15px;
  }
  .ant-popover-inner {
    border-radius: 8px;
    padding: 6px 10px;
  }
  .ant-popover-arrow {
    display: none;
  }
}

.menu-item.active {
  color: @theme-color;
  &::after {
    content: "";
    width: 100%;
    height: 4px;
    position: absolute;
    bottom: 11px;
    left: 0;
    background: @theme-color;
    border-radius: 2px;
  }
}
.other-menu-item {
  padding: 10px;
  padding-right: 32px;
  border-radius: 8px;
  cursor: pointer;
  &.active {
    color: #fff;
    background: @theme-color;
  }
  &.active:hover {
    color: #fff;
  }
  &:hover {
    color: @theme-color;
  }
}

.user-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 80px;
  border-left: 1px solid #9e9fa3;
  padding-left: 23px;
  height: 22px;
  cursor: pointer;
  .person-menu-item {
    padding: 10px;
    cursor: pointer;
    &:hover {
      color: @theme-color;
    }
  }
}

.user-logo {
  width: 12px;
  height: 14px;
  // margin-right: 7px;
}
</style>
